
// currenter
//------------------------------------------------------------
$(function(){
  if( $("body").is("#guide") ){
    $("#cont .tabs").autoCurrenter();

    // イレギュラー
    var url = location.href;
    var host = location.host;

    if( url.split(host)[1] == "/guide/" ){
      $("#cont .tabs li:eq(0)").addClass("current");
    }

    var city = $.url().param("city");
    if( city ){
      $("#cont .tabs li:eq(1)").addClass("current");
      $(".cmn-list-3 li").each(function(){
        var that = this;
        var href = $("a", this).attr("href");
        var prm = $.url(href).param("city");
        if(city ==  prm){
          $("a", that).addClass("current");
        }
      });
    }
  }

  if( $("body").is("#bureau.member") ){
    var cls = $.url().param("class");

    $(".cmn-list-3 li a").each(function(){
      var $that = $(this);
      var href = $(this).attr("href");
      if( href == "?class=" + cls ){
        $that.addClass("current");
      }
    });
  }

  if( $("body").is("#welcome") ){
    $("#cont .btm__menu").autoCurrenter();
  }
});


// WEBPACK FOOTER //
// ./_src/js/init/current.js